<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content' style="display: flex"> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='' style="margin-right:2%;">
        <dx-data-grid ref='refSellingPriceListGrid'
          :data-source='sellingPriceList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :auto-navigate-to-focused-row="false"
          @toolbar-preparing='onToolbarPreparing'
          @cellDblClick = 'onCellDblClick'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            file-name="판매가"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            :allowEditing='true'
            caption="고객사"
            data-field="고객사코드"
            :visible='true'
            sort-order="asc"
           >
            <DxLookup
              :data-source="customerLookup"
              display-expr="거래처명"
              value-expr="거래처코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="차종"
            data-field="차종"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="품번"
            data-field="품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="납입품번"
            data-field="납입품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="품명"
            data-field="품명"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품목유형"
            data-field="품목유형"
            :visible='true'
          >
            <DxLookup
              :data-source="productypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="자재유형"
            data-field="자재유형"
            :visible='true'
          >
            <DxLookup
              :data-source="meterialTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="판매가"
            data-field="가격"
            :visible='true'
          >
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="품번"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <div class=''>
        <dx-data-grid ref='refBatchSellingPriceListGrid'
          :data-source='batchSellingPriceList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :auto-navigate-to-focused-row="false"
          @toolbar-preparing='rightGridOnToolbarPreparing'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            file-name="판매가"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            :allowEditing='false'
            caption="고객사"
            data-field="고객사코드"
            sort-order="asc"
          >
            <DxLookup
              :data-source="customerLookup"
              display-expr="거래처명"
              value-expr="거래처코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="차종"
            data-field="차종"
            sort-order="asc"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="고객사품번"
            data-field="납입품번"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품번"
            data-field="품번"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품명/Error"
            data-field="품명"
            sort-order="asc"
            width="200"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="판매가"
            data-field="가격"
            format='#,##0'
            dataType="number"
            :visible='true'
          >
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="품번"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
      <input id="batch-detail-input" type="file" @change="onDetailFileChange($event)" accept=".xlsx" style='display: none;'>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel,
  DxLookup } from 'devextreme-vue/data-grid'
import AppLib from '../../share/AppLib'
// import { saveAs } from 'file-saver-es'
// import axios from 'axios'
import ExcelJS from 'exceljs'

export default {
  name: 'SellingPrice',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '판매가관리'
        }
      ],
      productypeLookup: null,
      meterialTypeLookup: null,
      customerLookup: null,
      // LEFT GRID
      sellingPriceList: [],
      // RIGHT GRID
      batchSellingPriceList: [],
      selectedDay: null,
      optionProductArray: null,
      lastSellingPriceRegDate: null,
      sellingPriceDate: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.productypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.customerLookup = this.$store.getters.getCustomerInfo
    this.selectedDay = AppLib.getToday()
    this.sellingPriceDate = `${AppLib.getToday().substring(0, 7)}-01`
    this.refreshSellingPriceList()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    /* ************ LEFT GRID START ************ */
    onCellDblClick (event) {
      console.log(event.text)
      this.$copyText(event.text).then(success => {
        // this.$snotify.info(`${event.text} 이 복사되었습니다`)
      })
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>판매가 조회</b></div>`
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>기준일:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 94,
            value: this.selectedDay,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onValueChanged: (args) => {
              this.selectedDay = args.value
              this.refreshSellingPriceList()
            }
          }
        }
      )
    },
    refreshSellingPriceList () {
      this.$_sp.runNoEncodeFindProc('spFindAllProductPriceInfoListByDate', { 적용일자: this.selectedDay })
        .then((data) => {
          this.sellingPriceList = this.$_.sortBy(this.$_sp.MakeModel(data), '적용일자').reverse()
          if (this.sellingPriceList.length > 0) {
            if (this.lastSellingPriceRegDate === null) {
              this.lastSellingPriceRegDate = this.sellingPriceList[0].적용일자
            }
          } else {
            this.lastSellingPriceRegDate = null
          }
        })
    },
    /* ************ LEFT GRID END   ************ */
    /* ************ RIGHT GRID START   ************ */
    checkRegDate (date) {
      if (date.substring(8, 10) !== '01') {
        this.$snotify.info('적용일자는 매월 1일만 가능합니다.')
        date = `${date.substring(0, 7)}-01`
        console.log(date)
      }
      if (this.lastSellingPriceRegDate === null) {
        this.sellingPriceDate = date
      } else {
        // let temp = `${AppLib.calcMonthFromToday(0).substring(0, 7)}-01`
        let last = AppLib.formatDateFromTimeStamp(this.lastSellingPriceRegDate)
        if (last > date) {
          this.$snotify.info(`적용일자는 ${last} 보다 커야 합니다.`)
          const lastDay = AppLib.getMonthLastDay(last.substring(0, 4), last.substring(5, 7))
          this.sellingPriceDate = AppLib.calcDateFromFormat(`${last.substring(0, 7)}-${lastDay}`, 1)
        } else {
          this.sellingPriceDate = date
        }
      }
      if (this.sellingPriceRegDateBox !== null) {
        this.sellingPriceRegDateBox.option({ value: this.sellingPriceDate })
      }
    },
    async onDetailFileChange ($event) {
      this.isLoading = true
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      this.batchSellingPriceList = []
      let vm = this
      let file = document.getElementById('batch-detail-input')['files'][0]
      this.$Q('#batch-detail-input').val('')
      let reader = new FileReader()

      reader.onloadend = function (event) {
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(function (workbook) {
          workbook.eachSheet(function (worksheet, sheetId) {
            if (worksheet.name !== '차종사양' && worksheet.name !== '생산계획' && worksheet.name !== '사양표' && worksheet.name !== '대수' && worksheet.name !== '제품가격' && worksheet.name.indexOf('Sheet') < 0) {
              vm.saveCarMap(worksheet, worksheet.name)
            }
          })
        })
      }
      reader.readAsArrayBuffer(file)
    },
    onSaveSellingPrice () {
      this.isLoading = true
      this.$_sp.runInsertOrUpdayeSqlProc('가격정보_판매가', ['적용일자', '품번'], ['차종', '품명'], this.batchSellingPriceList)
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('등록 되었습니다.')
          this.updateAllPriceLastDate()
          this.batchSellingPriceList = []
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            // this.$snotify.error('적용일 기준 등록된 품번(판매가)이 있습니다.')
          } else {
            // this.$snotify.error('적용일 기준 등록된 품번(판매가)이 있습니다.')
          }
        })
    },
    async saveCarMap (worksheet, company) {
      let row = null
      let value = null
      let dataJson = {}
      let emptyRow = 0
      for (let i = 8; i < 3000; i++) {
        row = worksheet.getRow(i)
        value = AppLib.getCellFromExcel(row, 2)
        if (value !== null && (value.indexOf('T O T A L') >= 0 || value.indexOf('TOTAL') >= 0)) continue
        if (value === null || value === '소급정산') {
          if (emptyRow === 0) {
            emptyRow++
            continue
          } else {
            console.log(`${company}  read row=${i - 8}`)
            break
          }
        }
        emptyRow = 0
        dataJson.고객사코드 = company
        dataJson.차종 = AppLib.getCellFromExcel(row, 2)
        dataJson.납입품번 = AppLib.getCellFromExcel(row, 3)
        dataJson.품번 = AppLib.getCellFromExcel(row, 4)
        dataJson.품명 = AppLib.getCellFromExcel(row, 5)
        dataJson.원단위 = AppLib.getCellFromExcel(row, 6)
        dataJson.단가 = AppLib.getCellFromExcel(row, 7)
        let temp = {
          적용일자: this.sellingPriceDate,
          고객사코드: this.$_.findWhere(this.customerLookup, { 거래처명: company }).거래처코드,
          차종: dataJson.차종,
          납입품번: dataJson.납입품번,
          품번: dataJson.품번,
          품명: dataJson.품명,
          가격: dataJson.단가
        }
        if (dataJson.단가 > 0) {
          this.batchSellingPriceList.push(temp)
        }
      }
      this.isLoading = false
    },
    rightGridOnToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>판매가 등록</b></div>`
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>기준일:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 94,
            value: this.sellingPriceDate,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onInitialized: (args) => {
              this.sellingPriceRegDateBox = args.component
            },
            onValueChanged: (args) => {
              this.checkRegDate(args.value)
              if (this.batchSellingPriceList.length > 0) {
                this.$snotify.warning('가격정보 엑셀파일 Load후 적용일자 변경은 유효하지 않습니다. 파일을 다시 로드하여 주세요.')
              }
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'file',
            text: '파일선택',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$Q('#batch-detail-input').click()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'save',
            text: '저장',
            type: 'success',
            focusStateEnabled: true,
            onClick: (args) => {
              this.onSaveSellingPrice()
            }
          }
        }
      )
    },
    updateAllPriceLastDate () {
      this.$_sp.runUpdateProc('spUpdateSalesPriceLastDate', [{ null: '' }])
        .then((data) => {
          setTimeout(() => {
            this.refreshSellingPriceList()
          }, 10)
        })
    }
    /* ************   RIGHT GRID END   ************ */
  }
}
</script>

<style lang="scss">

</style>
